import { useCallback, useMemo, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import GraniteError from 'granite-admin/utils/granite-error';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import queryString from 'query-string';
var websocketInstance = {};
function useWebSocket(props) {
  const {
    onConnectionOpen,
    onConnectionClose,
    onGetMessage,
    onGetError
  } = props || {};
  const config = useContext(ConfigContext);
  const authToken = getAuthToken();
  const {
    history
  } = useHistory();
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const {
    websocketMappings = null
  } = config || {};
  const loadWebsocketInstance = useCallback((url, headers = {}, protocols = [], forceCloseConnection = false) => {
    // if (!websocketMappings || !Object.keys(websocketMappings).length) {
    //   return;
    // } else
    if (websocketInstance.readyState === WebSocket.OPEN) {
      if (forceCloseConnection) {
        websocketInstance.close();
      } else return;
    }
    try {
      let params = {};
      const webSocketUrl = url || process.env.REACT_APP_WEBSOCKET_API_URL || '';
      if (authToken) {
        params = {
          ...params,
          auth_token: `Bearer ${authToken}`
        };
      }
      if (Object.keys(headers).length > 0) {
        params = {
          ...params,
          ...headers
        };
      }
      if (webSocketUrl) {
        websocketInstance = new WebSocket(`${webSocketUrl}?${queryString.stringify(params)}`, protocols);
      }
    } catch (e) {
      throw new GraniteError(e);
    }
  }, [authToken]);
  const sendData = data => {
    try {
      //data should be of format {"action": "test", "data": {}}
      if (websocketInstance.readyState === WebSocket.OPEN) {
        //if the connection is open
        websocketInstance.send(JSON.stringify(data));
      } else {
        console.log('websocket connection is not established');
      }
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  const closeConnection = forceClose => {
    try {
      if (websocketInstance.readyState === WebSocket.OPEN && !websocketInstance.bufferedAmount) {
        //if the connection is open and no data is queued for sending
        websocketInstance.close();
      } else if (forceClose) {
        //to close the connection forcefully, pass code and reason for closing. Although both parameters are optional.
        websocketInstance.close(1000, 'The connection successfully completed the purpose.');
      }
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  websocketInstance.onopen = function (event) {
    if (typeof onConnectionOpen === 'function') {
      onConnectionOpen(event);
    } else {
      console.log('Websocket connection is established', event);
    }
  };
  websocketInstance.onclose = function (event) {
    loadWebsocketInstance(); //as we need always on connection, load connection if gets close due to timeout or something.
    if (typeof onConnectionClose === 'function') {
      onConnectionClose(event);
    } else {
      console.log('Websocket connection is closed', event);
    }
  };
  function getPath(data, route) {
    const arr = route.split('/');
    const vars = arr.filter(a => a.includes(':')).map(a => a.replace(':', ''));
    vars.forEach(v => route = route.replace(':' + v, data[v]));
    return route; //in case generatePath not works
  }

  websocketInstance.onmessage = function (event) {
    const eventData = JSON.parse(event.data);
    if (websocketMappings && websocketMappings[eventData.action]?.showToast) {
      let redirectUrl = '';
      if (websocketMappings[eventData.action]?.autoRedirect && websocketMappings[eventData.action]?.redirectUrl) {
        redirectUrl = getPath(eventData.data, websocketMappings[eventData.action].redirectUrl);
      }
      grandEmitter.emit('SHOW_TOAST', {
        message: websocketMappings[eventData.action]?.toastMsg,
        status: 'info',
        ...(websocketMappings[eventData.action]?.autoRedirect && websocketMappings[eventData.action]?.redirectUrl && {
          redirect: () => history.push(redirectUrl)
        })
      });
    }
    if (websocketMappings && websocketMappings[eventData.action]?.volatileStorage) {
      localStorage.setItem(eventData.action, eventData.data);
    }
    if (typeof onGetMessage === 'function') {
      onGetMessage(eventData);
    } else {
      console.log('Getting data over Websocket connection: ', event);
    }
  };
  websocketInstance.onerror = function (event) {
    if (typeof onGetError === 'function') {
      onGetError(event);
    } else {
      console.log('Getting error over Websocket connection: ', event);
    }
  };
  return {
    websocketInstance,
    loadWebsocketInstance,
    sendData,
    closeConnection
  };
}
export default useWebSocket;